import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

export function Hero() {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	return (
		<div className={styles.heroWrapper}>
			<div className={styles.hero}>
				<div>
					<p className={styles.eyebrow}>{t('hero.eyebrow')}</p>
					<h1>{t('hero.title')}</h1>
					<p>{t('hero.description')}</p>
				</div>
				<div className={styles.heroSide} aria-label={t('hero.terms-label')}>
					<div className={styles.heroFact}>
						<strong>{t('hero.zero-commission')}</strong>
						<span>{t('hero.zero-commission-note')}</span>
					</div>
					<div className={styles.heroFact}>
						<strong>{t('hero.postpaid')}</strong>
						<span>{t('hero.postpaid-note')}</span>
					</div>
				</div>
			</div>
		</div>
	);
}
